// A2-533 (operator 2026-10-25, after setting a rate on two cards: "is this
// good logic that it sends me to re-run twice?"). Every answer given on this
// step is saved at once and applied together by the NEXT calculation, so one
// re-run is enough. This bar says how many are waiting and offers that one
// re-run; the cards' own notes point here instead of each sending the
// operator to Step 3.
// A2-622 (operator 2026-10-31, "nothing prompts for a re-run"): answers given
// on ANY calculation of the same upload count, and a screen showing an older
// calculation names the newer one.
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { authClient } from "../../lib/authApi";

export const SavedAnswersBar = ({ calcId, refreshKey, locked = false }) => {
  const { t } = useTranslation();
  const [saved, setSaved] = useState(null);
  useEffect(() => {
    if (!calcId) return undefined;
    let live = true;
    authClient.get(`/runs/calc/${calcId}/saved-answers`)
      .then(({ data }) => { if (live) setSaved(data); })
      .catch(() => { if (live) setSaved(null); });   // no bar rather than a wrong one
    return () => { live = false; };
  }, [calcId, refreshKey]);
  if (!saved) return null;
  const newer = saved.newer_calc;
  if (!saved.answers && !newer) return null;
  return (
    // A2-637 step 6 (operator's Step 4 check 2026-11-02: "where to click for
    // re-run? ... just saw the re-run button at the top, by accident"): the
    // bar stays in view while the operator answers further down, BELOW the
    // app header (sticky top-0, h-16, components/Header.jsx) - at top-2 it
    // slid under it.
    <div data-testid="saved-answers-sticky" className="sticky top-[4.5rem] z-20 flex flex-col gap-2">
    {newer && (
      <div data-testid="newer-calc-note"
        className="flex items-center justify-between gap-3 flex-wrap rounded-lg border border-slate-300 dark:border-slate-600 bg-slate-50 dark:bg-slate-900 px-4 py-2.5 text-xs text-slate-800 dark:text-slate-100">
        <span>
          {t("ui.review_queue.newer_calc", {
            defaultValue: "This is not the latest calculation of this upload. A newer one was run later: its figures are the current ones.",
          })}
        </span>
        <Link to={`/?calc_id=${newer.id}`} data-testid="newer-calc-open"
          className="shrink-0 font-bold px-3 py-1.5 rounded-md border border-slate-400 dark:border-slate-500 hover:bg-slate-100 dark:hover:bg-slate-800">
          {t("ui.review_queue.newer_calc_open", { defaultValue: "Open the latest →" })}
        </Link>
      </div>
    )}
    {!!saved.answers && (
    <div data-testid="saved-answers-bar"
      className="flex items-center justify-between gap-3 flex-wrap rounded-lg border border-emerald-300 dark:border-emerald-800 bg-emerald-50 dark:bg-emerald-950 px-4 py-2.5 shadow-lg text-xs text-emerald-900 dark:text-emerald-100">
      <span>
        {t("ui.review_queue.saved_answers", {
          answers: saved.answers, rows: saved.rows,
          defaultValue: `${saved.answers} answer(s) saved for ${saved.rows} row(s). The figures change when the calculation re-runs: give your other answers first, then re-run once.`,
        })}
      </span>
      {/* A2-581 screen map lead 13: on a signed or locked calc a run starts a
          separate, unrelated calculation, never a change to this filing */}
      {locked ? (
        <span data-testid="saved-answers-locked" className="shrink-0">
          {t("ui.review_queue.saved_answers_locked", {
            defaultValue: "This calculation is locked for filing: a re-run makes a separate one. To change this filing, supersede it in Step 6.",
          })}
        </span>
      ) : (
        <Link to="/workflow/calculate" data-testid="saved-answers-rerun"
          className="shrink-0 font-bold px-3 py-1.5 rounded-md bg-emerald-700 hover:bg-emerald-600 text-white">
          {t("ui.review_queue.saved_answers_rerun", { defaultValue: "Re-run once now →" })}
        </Link>
      )}
    </div>
    )}
    </div>
  );
};

export default SavedAnswersBar;
